export function formatPrice(value, currency = 'PLN') {
    const locale = currency === 'PLN' ? 'pl-PL' : 'de-DE';
    return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(value || 0);
}
